import React from 'react';

import PropTypes from "prop-types";
import { bindActionCreators } from 'redux';
import { connect } from "react-redux";
import { Field, getFormValues } from 'redux-form';

import store from '../../store/redux_store.js';
import { Client } from '../../client';

import * as renderUpdateActions from "../../actions/render";
import { resetContrast } from '../../actions/general';
import { toggleModal } from '../../actions/ui';
import { initContrastSearch } from '../../actions/fabric';

import {
  getLayoutAttr,
  getSelectedContrasts,
  makeGetFabricValuesBySet,
  getContrastSearchTerms,
} from '../../selectors/entities/general';
import {
  getNormalizedButtonsValues,
  getNormalizedContrastTypeValues
} from '../../selectors/entities/config';
import { MakeGetCompatibility } from '../../selectors/entities/compatibility';
import { getContrastModalState } from '../../selectors/entities/ui';

import {
  ToggleComponent,
  CheckboxComponent,
  SelectComponent,
  BlockComponent,
  InputComponent,
  ColorComponent,
  ThreadComponent,
  FontComponent,
  SeparatorComponent,
  TextBlockComponent,
  EmbroideryBlockComponent,
  ContrastsSectionComponent,
} from '../FieldAttrsComponents';
import GroupBreakerComponent from '../FieldAttrsComponents/GroupBreaker';
import { HeaderComponent } from '../FieldAttrsComponents/styled';
import { FieldWrapper } from '../Styled';

const CommentWrapper = ({ comment }) => {
  const spanRef = React.useRef(null);
  const [someHTML,] = React.useState(comment);

  React.useEffect(() => {
    if (spanRef.current) spanRef.current.innerHTML = someHTML;
  }, [spanRef.current, someHTML]);

  return <div className="b-fabric-info__comment-wrapper" style={{ margin: '20px 0 20px 0' }}>
    <div ref={spanRef} style={{ textAlign: 'center' }} />
  </div>
}


class BuilderFieldAttr extends React.Component {

  constructor(props) {
    super(props);
    this.state = {}
  }

  fieldChange = (attrName, event, value) => {
    this.setState({ [attrName]: value })
  }

  handleCheckboxChange = (value) => {
    this.props.actions.resetContrast(value);
  }

  checkConditionalRender = (item) => {
    const formValues = this.props.formValues;
    if (item.conditionRender) {
      let condition;
      if (item.condition.type === "formValue") {
        const keyAttr = item.condition.attrName;
        const keyValue = item.condition.attrValue;
        condition = Boolean(formValues[keyAttr]) === keyValue;
      }
      if (!condition) {
        return false
      }
    }
    return true;
  }

  checkToggleRender = ({ toggleItem, toggle }) => {
    const formValues = this.props.formValues;
    if (toggleItem) {
      if (toggleItem && formValues[toggle] !== toggleItem) {
        return false
      }
    }
    return true;
  }

  getShortNameOrDefault({ shortName, displayName }) {
    return shortName || displayName
  }

  render() {

    const {
      section,
      formValues,
      buttonsValues,
      contrasts,
      contrastTypesValues,
      renderUpdateActions,
      isMobile,
      contrastSearchTerm,
      actions: {
        initContrastSearch,
        toggleModal,
      },
    } = this.props

    const state = store.getState();

    const fields = Object.values(section.enums).map((item, index) => {

      if (
        !this.checkConditionalRender(item) ||
        !this.checkToggleRender(item)) {
        return null;
      }

      const {
        attrName,
        onChange,
        variation,
        type,
        shortName,
        values,
        fabricSet,
        updatePrice,
        updateRender,
        excludedAttrs,
        objectId,
        displayName,
        sectionClassName,
        hideTitle,
        price,
        placeholder,
        ...others
      } = item;

      const { contrastType } = formValues;

      const disabled = MakeGetCompatibility(attrName)(state);
      const valuesArray = values ? Object.values(values) : [];
      const nameOrDefault = this.getShortNameOrDefault(item);
      const contrastValue = contrasts[contrastType] || {};

      const handleChange = (inputValue) => {
        if (renderUpdateActions.hasOwnProperty(onChange)) {
          renderUpdateActions[onChange](inputValue, attrName, updatePrice, updateRender)
        }
      }

      const handleContrastClean = () => {
        handleChange(null); 
        renderUpdateActions['cleanSelectedContrast'](attrName);
      }

      switch (type) {
        case 'checkbox':
          return (
            <Field
              key={index}
              name={attrName}
              component={CheckboxComponent}
              label={nameOrDefault}
              values={values}
              disabled={disabled}
              type="bool"
              onChange={handleChange}
              {...others}
            />
          )

        case 'block':
          return (
            <Field
              key={index}
              displayName={displayName}
              name={attrName}
              variation={variation}
              values={valuesArray}
              component={BlockComponent}
              imageGetFunction={Client.getImageDetailPreview}
              disabled={disabled}
              isMobile={isMobile}
              excludedAttrs={excludedAttrs}
              hideTitle={hideTitle}
              onChange={handleChange}
            />
          )

        case 'block-light':
          return (
            <Field
              key={index}
              displayName={displayName}
              name={attrName || ''}
              variation={variation}
              values={valuesArray}
              component={TextBlockComponent}
              imageGetFunction={Client.getImageDetailPreview}
              disabled={disabled}
              isMobile={isMobile}
              excludedAttrs={excludedAttrs}
              hideTitle={hideTitle}
              onChange={handleChange}
            />
          )

        case 'block-light2':
	  return (
	    <Field
	      key={index}
              displayName={displayName}
              name={attrName || ''}
              variation={variation}
              values={valuesArray}
              component={EmbroideryBlockComponent}
              imageGetFunction={Client.getImageDetailPreview}
              disabled={disabled}
              isMobile={isMobile}
              excludedAttrs={excludedAttrs}
              hideTitle={hideTitle}
              onChange={handleChange}
            />
          )
        case 'select':
          return (
            <Field
              key={index}
              label={nameOrDefault}
              name={attrName}
              onChange={handleChange}
              values={valuesArray}
              component={SelectComponent}
              disabled={disabled}
              isMobile={isMobile}
              {...others}
            />
          )

        case 'color':
          return (
            <Field
              key={index}
              displayName={displayName}
              name={attrName}
              values={valuesArray}
              component={ColorComponent}
              disabled={disabled}
              onChange={handleChange}
              objectId={objectId}
            />
          )

        case 'button':
          return (
            <Field
              key={index}
              name={attrName}
              values={buttonsValues}
              variation='image'
              component={BlockComponent}
              imageGetFunction={Client.getRemarkImageUrlButton}
              onChange={handleChange}
              disabled={disabled}
            />
          )

        case 'buttonsThread':
          return (
            <Field
              key={index}
              name={attrName}
              variation='color'
              values={valuesArray}
              component={ThreadComponent}
              onChange={handleChange}
              disabled={disabled}
            />
          )

        case 'toggle':
          return (
            <Field
              key={index}
              name={attrName}
              values={valuesArray}
              component={ToggleComponent}
              disabled={disabled}
              isMobile={isMobile}
              onChange={handleChange}
              {...others}
            />
          )

        case 'toggle-contrasts':
          return (
            <Field
              key={index}
              name={attrName}
              values={contrastTypesValues}
              component={ToggleComponent}
              behaviour='checkbox'
              disabled={disabled}
              isMobile={isMobile}
              showPrice={true}
              onChange={handleChange}
              isContrast={true}
              contrasts={contrasts}
              haveCheckedLabel={true}
              {...others}
            />
          )

        case 'lazy-image-list':
          const fabrics = makeGetFabricValuesBySet(values.fabricSet)(state);
          return (
            <ContrastsSectionComponent
              key={index}
              displayName={nameOrDefault}
              label={nameOrDefault}
              values={fabrics}
              value={contrastValue}
              disabled={disabled}
              isMobile={isMobile}
              contrastType={contrastType}
              onChange={handleChange}
              searchTerm={contrastSearchTerm}
              onFabricSearch={(v) => initContrastSearch(v)}
              onFabricCancel={handleContrastClean}
              openModal={() => toggleModal('CONTRAST_PREVIEW')}
              closeModal={() => toggleModal('CONTRAST_PREVIEW')}
              isModalOpened={this.props.contrastModalOpened}
            />
          )

        case 'input':
          return (
            <Field
              key={index}
              name={attrName}
              onChange={handleChange}
              variation={'center'}
              label={nameOrDefault}
              component={InputComponent}
              disabled={disabled}
              isMobile={isMobile}
              placeholder={placeholder}
              type="text"
            />
          )

        case 'font':
          return (
            <Field
              key={index}
              values={valuesArray}
              name={attrName}
              onChange={handleChange}
              component={FontComponent}
              displayName={nameOrDefault}
              label={nameOrDefault}
            />
          )

        case 'separator':
          return (
            <SeparatorComponent key={index} />
          )

        case 'group-breaker':
          return (
            <GroupBreakerComponent key={index} />
          )

        case 'header':
          return (
            <HeaderComponent key={index}>
              {displayName}
            </HeaderComponent>
          )

        case 'text-field':
          return (
            <CommentWrapper key={index} comment={item.text} />
          )
        default:
          return null
      }

    })

    return (
      <FieldWrapper>
        {fields}
      </FieldWrapper>
    );
  }
}

BuilderFieldAttr.propTypes = {
  formValues: PropTypes.object.isRequired,
  section: PropTypes.object.isRequired,
  contrasts: PropTypes.object.isRequired,
  buttonsValues: PropTypes.array.isRequired,
  contrastTypesValues: PropTypes.array.isRequired,
  contrastModalOpened: PropTypes.bool,
  sectionName: PropTypes.string.isRequired,
  isMobile: PropTypes.bool.isRequired,
  contrastSearchTerm: PropTypes.string,
  actions: PropTypes.object.isRequired,
  renderUpdateActions: PropTypes.object.isRequired,
};


const getValues = getFormValues('detail');

function mapStateToProps(state, ownProps) {
  const section = getLayoutAttr(state, ownProps.sectionName)
  const formValues = getValues(state);
  const contrasts = getSelectedContrasts(state);

  const contrastTypesValues = getNormalizedContrastTypeValues(state);
  const buttonsValues = getNormalizedButtonsValues(state);
  const contrastModalOpened = getContrastModalState(state);
  const isMobile = state.ui.isMobile;

  const contrastSearchTerm = getContrastSearchTerms(state);

  return {
    formValues,
    section,
    contrasts,
    buttonsValues,
    contrastTypesValues,
    contrastModalOpened,
    isMobile,
    contrastSearchTerm,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({
      resetContrast,
      initContrastSearch,
      toggleModal,
    }, dispatch),
    renderUpdateActions: bindActionCreators(renderUpdateActions, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(BuilderFieldAttr);
